<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import { Checkbox, Form, FormItem, Input, InputNumber, Option, Select, Switch, Tooltip } from 'element-ui';
    import Vue from "vue";
    import VueButton from '~/components/button/components/button';
    import OrgSecurityQuestionsForm from './ps_org_security_questions_form';

    Vue.use(Input);
    Vue.use(InputNumber);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Switch);
    Vue.use(Tooltip);
    Vue.use(Checkbox);
    Vue.use(Select);
    Vue.use(Option);

    export default {
        name: 'org-security-question-settings-form',

        components: {
            VueButton,
            OrgSecurityQuestionsForm
        },

        computed: {
            ...mapState('passwordSettings', [
                'loading',
                'orgSecurityQuestionSettingsForm',
                'allAdminUsers',
                'dialogVisible'
            ])
        },

        methods: {
            ...mapMutations('passwordSettings', [
                'updateDialogVisible',
                'updateLoading'
            ]),

            ...mapActions('passwordSettings', [
                'getOrgSecurityQuestionsForm'
            ]),

            customizeSecurityQuestions() {
                this.updateDialogVisible({
                    orgSecurityQuestions: true
                });
            },

            handleRequireAdminApprovalCheckbox() {
                if (this.orgSecurityQuestionSettingsForm.requireAdminApprovalForPasswordReset === '0') {
                    this.orgSecurityQuestionSettingsForm.adminUserIdsForPasswordReset = [];
                }
            }
        }
    }
</script>

<template>
    <div>
        <el-form ref="orgSecurityQuestionSettingsForm"
                 :model="orgSecurityQuestionSettingsForm">

            <el-form-item prop="require_security_questions">
                <div class="org-security-question-settings-form-label ">
                    Require security questions for all users
                </div>

                <div class="ps-form__action">
                    <el-switch v-model="orgSecurityQuestionSettingsForm.requireForAllUsers"
                               on-text=""
                               off-text=""
                               on-value="1"
                               off-value="0"
                               :width="60">
                    </el-switch>
                </div>
            </el-form-item>

            <hr class="ps-form__hr">

            <h3>Security Questions Setup</h3>

            <h5 class="el-form-item__label">Number of required security questions</h5>
            <el-form-item>
                <el-input-number v-model="orgSecurityQuestionSettingsForm.securityQuestionsRequired"
                                 :min="1"
                                 :max="5">
                </el-input-number>
            </el-form-item>

            <h5 class="el-form-item__label">Number of times users can skip setup</h5>
            <el-form-item>
                <el-input-number v-model="orgSecurityQuestionSettingsForm.skipsAllowed"
                                 :min="1">
                </el-input-number>
            </el-form-item>
            <p><strong>Note:</strong> Users will be asked to select and answer questions on their next login.</p>

            <el-form-item style="margin-bottom: 0; line-height: 0">
                <el-checkbox v-model="orgSecurityQuestionSettingsForm.requireAdminApprovalForPasswordReset"
                             true-label=1
                             false-label=0
                             @change="handleRequireAdminApprovalCheckbox"
                             style="margin-bottom: 0; line-height: 0">
                    Require admin approval for password resets initiated before user setup is complete
                </el-checkbox>
            </el-form-item>

            <el-form-item v-if="orgSecurityQuestionSettingsForm.requireAdminApprovalForPasswordReset === '1'">
                <div class="org-security-question-settings-form-label ">
                    Notify the following admin user(s):
                </div>

                <el-select v-model="orgSecurityQuestionSettingsForm.adminUserIdsForPasswordReset"
                           multiple
                           clearable
                           filterable>

                    <el-option v-for="adminUser in allAdminUsers"
                               :key="adminUser.user_id"
                               :label="adminUser.user_full_name"
                               :value="adminUser.user_id">
                    </el-option>
                </el-select>
            </el-form-item>

            <hr class="ps-form__hr">
            <h3>Password Reset</h3>
            <h5 class="el-form-item__label">Number of answers required during password reset</h5>
            <el-form-item>
                <el-input-number v-model="orgSecurityQuestionSettingsForm.passwordResetAnswersRequired"
                                 :min="1"
                                 :max="5">
                </el-input-number>
            </el-form-item>

            <hr class="ps-form__hr">
            <vue-button class="org-security-question-settings-btn"
                        :loading="loading.orgSecurityQuestions"
                        @click="customizeSecurityQuestions()">
                <span class="org-security-question-settings-btn-txt ">Customize Security Questions</span> <span
                class="org-security-question-settings-txt">(optional)</span>
            </vue-button>
            <br/><br/>
            <p><strong>Note:</strong> By default, Total Expert provides a list of
                10 security questions for users to choose from. Customize security questions to edit the list
                and/or add custom questions.
            </p>

        </el-form>

        <org-security-questions-form v-if="dialogVisible.orgSecurityQuestions"></org-security-questions-form>
    </div>
</template>